import axios, { AxiosError } from "axios";
import { TypeUser } from "../utility/types/user";
import { alert, alertRedirect } from "../@core/components/alert";
import {
  Navigate,
  redirect,
  redirectDocument,
  useNavigate,
} from "react-router-dom";

const token = JSON.parse(localStorage.getItem("@realitymed.token") as any);

export const api = axios.create({
  baseURL: import.meta.env.VITE_APP_URL_API,
  timeout: 1200000, // 20minutos
  timeoutErrorMessage: "timeout",
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
});
type FailedRequestData = {
  onSuccess: (token: string) => void;
  onFailure: (err: AxiosError) => void;
};
let isRefreshing = false;
let failedRequest: FailedRequestData[] = [];

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    const user: TypeUser = JSON.parse(
      localStorage.getItem("@realitymed.user") as any
    );
    if (error.response?.status === 401) {
      if (error.response.data === "token expirado") {
        const originalConfig: any = error.config;
        if (!isRefreshing) {
          isRefreshing = true;

          api
            .get("refresh")
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("@realitymed.token", JSON.stringify(token));
              api.defaults.headers["Authorization"] = `Bearer ${token}`;

              failedRequest.forEach((request) => {
                request.onSuccess(token);
              });
              failedRequest = [];
            })
            .catch((err) => {
              failedRequest.forEach((request) => request.onFailure(err));
              failedRequest = [];
            })
            .finally(() => {
              isRefreshing = false;
            });
        }
        return new Promise((resolve, reject) => {
          failedRequest.push({
            onSuccess: (access_token: string) => {
              originalConfig.headers[
                "Authorization"
              ] = `Bearer ${access_token}`;
              resolve(api(originalConfig));
            },
            onFailure: (err: AxiosError) => {
              reject(err);
            },
          });
        });
      } else if (
        error.response.data === "Tempo de atualização de token expirado" ||
        error.response.data == "token na blacklist"
      ) {
        localStorage.removeItem("@realitymed.user");
        localStorage.removeItem("@realitymed.token");
        alert("Acesso expirado, redirecionado para login", "error");
        location.href = "/login";
      }
      // else if (error.response.data == "Acesso não autorizado") {
      //   localStorage.removeItem("@realitymed.user");
      //   localStorage.removeItem("@realitymed.token");
      //   alertRedirect(
      //     "Identificamos acesso simultâneo nessa conta. Você será redirecionado para o login.",
      //     "error",
      //     "/login"
      //   );
      // }
    }
    // if (error.response?.status === 404) {
    //   if (error.response.data == "usuario não encontrado") {
    //     localStorage.removeItem("@realitymed.user");
    //     localStorage.removeItem("@realitymed.token");
    //     alert("Usuário não encontrado, redirecionado para login", "error");
    //     location.href = "/login";
    //   }
    // }

    // if (error.response?.status === 0 || error.code == "ERR_NETWORK") {
    //   alert(
    //     "Servidor da api fora do ar, Entrar em contato com o administrador. Tente novamente mais tarde",
    //     "error"
    //   );
    //   error["data"] =
    //     "Servidor da api fora do ar, Entrar em contato com o administrador. Tente novamente mais tarde";
    //   return Promise.reject(error);
    // }
    console.log(error);
    return Promise.reject(error);
  }
);
export function getRequest(URL, config?) {
  return api.get(`${URL}`, config).then((response) => response.data);
}

export function postRequest(URL, payload) {
  return api.post(`${URL}`, payload).then((response) => response.data);
}
export function postRequestMultiPart(URL, payload) {
  return api
    .post(`${URL}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
}
export function patchRequest(URL, payload) {
  return api.patch(`${URL}`, payload).then((response) => response.data);
}
export function putRequest(URL, payload?) {
  return api.put(`${URL}`, payload).then((response) => response.data);
}
export function deleteRequest(URL, config?) {
  return api.delete(`${URL}`, config).then((response) => response.data);
}
